import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';
import moment from 'moment';

@Component({
  selector: 'app-my-jobs',
  templateUrl: './my-jobs.component.html',
  styleUrls: ['./my-jobs.component.css']
})
export class MyJobsComponent implements OnInit {
  jobs: any[] = [];
  pageSize: number = 6;
  page: number = 1;

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    this.getJobPosts();
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil((this.jobs?.length || 0) / this.pageSize));
  }

  get pagedJobs(): any[] {
    const start = (Math.max(1, this.page) - 1) * this.pageSize;
    return (this.jobs || []).slice(start, start + this.pageSize);
  }

  prevPage(): void {
    if (this.page > 1) this.page -= 1;
  }

  nextPage(): void {
    if (this.page < this.totalPages) this.page += 1;
  }

  getJobPosts() {
    this.ngxService.start();
    this.authenticationService.getJobPosts().subscribe(
      (response: any) => {
        console.log('API Response:', response);
        // Handle different response structures
        if (Array.isArray(response)) {
          // Direct array response
          this.jobs = response;
        } else if (Array.isArray(response?.items)) {
          // Response with items array (current API structure)
          this.jobs = response.items;
        } else if (Array.isArray(response?.data)) {
          // Response with data property
          this.jobs = response.data;
        } else {
          this.jobs = [];
        }
        console.log('Jobs array:', this.jobs);
        this.page = 1;
        this.ngxService.stop();
      },
      (error) => {
        this.ngxService.stop();
        Swal.fire(
          'Error',
          error.error?.message || 'Failed to load jobs.',
          'error'
        );
      }
    );
  }

  createJob() {
    this.router.navigate(['/create-job']);
  }

  formatDate(date: any): string {
    if (!date) return '-';
    return moment(date).format('MMM DD, YYYY');
  }

  isJobExpired(activeTill: any): boolean {
    if (!activeTill) return false;
    return moment(activeTill).isBefore(moment());
  }

  getJobLocation(job: any): string {
    // Check if it's a remote job first
    if (job?.jobBasics?.remoteJob === 'Yes') {
      return 'Remote';
    }
    
    // Check recruiting address first (more specific)
    if (job?.recruitingAddress?.address) {
      const addr = job.recruitingAddress;
      const parts = [addr.address, addr.city, addr.state, addr.country].filter(Boolean);
      return parts.length > 0 ? parts.join(', ') : addr.address;
    }
    
    // Check job basics location
    if (job?.jobBasics?.location?.streetAddress) {
      return job.jobBasics.location.streetAddress;
    }
    if (job?.jobBasics?.location?.city) {
      return job.jobBasics.location.city;
    }
    
    return '-';
  }
}
